import MouseTracking from './MouseTracking';

export default {
  __init__: [ 'mouseTracking' ],
  mouseTracking: [ 'type', MouseTracking ]
};
